import { render, staticRenderFns } from "./despatched-list.vue?vue&type=template&id=4cabb210"
import script from "./despatched-list.vue?vue&type=script&lang=js"
export * from "./despatched-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports